export default "__VITE_ASSET__BebiaK$t__"